export default __webpack_public_path__ + "static/media/honeymoon5.ae52301f.webp";